"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultRootSelector = "#page-modal-dialog-wait-backdrop";
const jQueryStatic = require("jquery");
class ModalDialogWaitBackdrop {
    constructor(jQuery = jQueryStatic, rootSelector = DefaultRootSelector) {
        this.jQuery = jQuery;
        this.rootSelector = rootSelector;
    }
    setVisibility(visible) {
        const element = this.jQuery(this.rootSelector);
        if (visible) {
            element.show();
        }
        else {
            element.hide();
        }
    }
    show() {
        this.setVisibility(true);
    }
    hide() {
        this.setVisibility(false);
    }
}
exports.default = ModalDialogWaitBackdrop;
